import styled from "styled-components";

export const PageWrapper = styled.div`
    @media (max-width: 768px) {
        padding: 0 4px;
    }
`;

export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding: 10px;
    background: #f5f5f5;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding: 10px 12px;
    }
`;

export const BackButton = styled.b`
    cursor: pointer;
    color: #1890ff;
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const PoolTitle = styled.h3`
    margin: 0;
    color: #262626;
    font-size: 20px;
    font-weight: 600;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

export const CreateFormTableWrapper = styled.div`
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .ant-table {
        min-width: 600px;
    }

    @media (max-width: 768px) {
        margin: 0 -4px;
        padding: 0 4px;
    }
`;

export const LevelFormRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px;
    gap: 0;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        padding: 10px 8px;
        gap: 8px;

        .ant-form-item {
            margin-right: 0 !important;
            width: 100%;
        }

        .ant-input {
            width: 100% !important;
        }

        .ant-btn {
            width: 100%;
        }
    }
`;

export const DataTableWrapper = styled.div`
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    @media (max-width: 768px) {
        margin: 0 -4px;
        padding: 0 4px;

        .ant-table-cell {
            font-size: 11px;
            padding: 4px 6px !important;
            white-space: nowrap;
        }

        .ant-tag {
            font-size: 11px;
            margin-right: 0;
            padding: 0 4px;
        }

        .ant-btn-sm {
            font-size: 11px;
            padding: 0 6px;
        }
    }
`;

export const FilterSection = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 16px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;

        .ant-select {
            width: 100% !important;
        }

        .ant-btn {
            margin-left: 0 !important;
            width: 100%;
        }
    }
`;

export const EditModalLevelRow = styled.div`
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;

        .ant-form-item {
            display: block !important;
            margin-right: 0 !important;
            width: 100%;
        }

        .ant-input {
            width: 100% !important;
        }
    }
`;

export const EditModalTableWrapper = styled.div`
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .ant-table {
        min-width: 600px;
    }
`;

export const EditModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
    margin-right: 8px;
    gap: 8px;

    @media (max-width: 768px) {
        margin-right: 0;
        flex-direction: column;

        .ant-btn {
            width: 100%;
        }
    }
`;
